module.exports = __webpack_public_path__ + "static/media/18ECA32.0aee5d86.jpg";